import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [labels, setLabels] = useState(undefined);
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");

  useEffect(() => {
    // Load localized content
    const localized = JsonData?.i18n?.[lang];
    if (localized) {
      setLandingPageData(localized);
      setLabels(localized.Labels || undefined);
    } else {
      setLandingPageData(JsonData);
      setLabels(undefined);
    }

    // Set document language and direction
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
      document.documentElement.dir = lang === "ur" ? "rtl" : "ltr";
    }
    localStorage.setItem("lang", lang);
  }, [lang]);

  return (
    <div>
      <Navigation
        labels={labels}
        lang={lang}
        onToggleLang={() => setLang(lang === "en" ? "ur" : "en")}
      />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} labels={labels} />
      <About data={landingPageData.About} labels={labels} />
      <Services
        data={landingPageData.Services}
        intro={landingPageData.ServicesIntro}
        labels={labels}
      />
      <Gallery data={landingPageData.Gallery} labels={labels} />
      {/* <Testimonials data={landingPageData.Testimonials} /> */}
      {/* <Team data={landingPageData.Team} /> */}
      <Contact data={landingPageData.Contact} labels={labels} />
    </div>
  );
};

export default App;
